module.exports = __webpack_public_path__ + "assets/52422f17f1dc8e59f486d1b91533f1d7.png";